<template>
  <div>
    <button class="close-modal" @click="closeModal">×</button>
    <h2 class="form-title">Add New {{ modalTitle }}</h2>

    <form class="form" @submit="handleSubmit">
      <div v-if="modalTitle !== 'Biochar Application' &&  modalTitle !== 'Biochar Partner'" class="input__container">
        <label for="name" class="form__label"
          >{{ getMarkerTypeName }} Name</label
        >
        <input
          id="name"
          type="text"
          class="form__input"
          placeholder=" "
          v-model="addMarkerForm.name"
          required
        />
      </div>

      <!-- For Customer Factory -->
      <div v-if="modalTitle == 'Customer Factory'" class="form__div">
        <div class="input__container">
          <label for="phoneNumber" class="form__label"
            >{{ getMarkerTypeName }} Phone number(s)</label
          >
          <input
            id="phoneNumber"
            type="text"
            class="form__input"
            placeholder=" "
            v-model="addMarkerForm.phoneNumber"
          />
        </div>
        <p>Select Raw Material</p>
        <b-form-checkbox-group
          dropdownTitle="Raw Material"
          v-model="selected"
          :options="options"
          class="select"
          value-field="item"
          text-field="name"
        ></b-form-checkbox-group>
      </div>

      <div v-if="modalTitle === 'Factory Marker'" class="form__div">
        <SelectDropdown
          :options="[
            'FFB Mill',
            'Crushing Mill',
            'Deshelling Mill',
            'Refinery',
            'Kraken II',
            'Carbonizer',
            'Biochar Facility',
          ]"
          class="select"
          dropdownTitle="Type"
          @onInput="handleSelect"
          :reset="reset"
          @onReset="handleReset"
        />
      </div>

      <div v-if="modalTitle === 'Customer Factory'" class="form__div">
        <SelectDropdown
          :options="[
            'Crushing Mill',
            'Deshelling Mill',
            'Refinery',
            'Kraken II',
            'Cement',
            'Carbonizer',
            'Other Industries',
          ]"
          class="select"
          dropdownTitle="Type"
          @onInput="handleSelect"
          :reset="reset"
          @onReset="handleReset"
        />
      </div>

      <!-- Raw Materials and Input Rate for Factory Marker (Biochar Facility Type) -->
      <div
        v-if="
          modalTitle === 'Factory Marker' &&
          addMarkerForm.type === 'Biochar Facility'
        "
        class="form__div"
      >
        <p>Select Raw Material</p>
        <b-form-checkbox-group
          dropdownTitle="Raw Material"
          v-model="selectedBiocharMaterials"
          :options="biocharMaterialOptions"
          class="select"
          value-field="item"
          text-field="name"
        ></b-form-checkbox-group>
      </div>
      <div
        v-if="
          modalTitle === 'Factory Marker' &&
          addMarkerForm.type === 'Biochar Facility'
        "
        class="input__container"
      >
        <input
          id="inputRate"
          type="number"
          class="form__input"
          placeholder=" "
          v-model="addMarkerForm.inputRate"
        />
        <label for="inputRate" class="form__label">Input Rate (per day)</label>
      </div>

      <!-- Raw Materials for Factory Marker (Other Types) -->
      <div
        v-if="
          modalTitle === 'Factory Marker' &&
          addMarkerForm.type !== 'Biochar Facility'
        "
        class="form__div"
      >
        <SelectDropdown
          :options="['FFB', 'P1', 'P2', 'PKO', 'PKS']"
          class="select"
          dropdownTitle="Raw Material"
          @onInput="handleRawMaterialSelect"
          :reset="reset"
          @onReset="handleReset"
        />
      </div>

      <div v-if="modalTitle === 'Factory Marker'" class="form__div">
    <div class="input__container">
      <label class="form__label">Image URLs (Optional)</label>
      <div class="url-inputs-container">
        <div
          v-for="(url, index) in addMarkerForm.imageUrls"
          :key="`factory-url-${index}`"
          class="url-input-row"
        >
          <input
            type="text"
            class="form__input url-input"
            v-model="addMarkerForm.imageUrls[index]"
            placeholder="Enter Google Drive Image URL"
          />
          <button
            v-if="index !== 0"
            type="button"
            class="cancel-btn"
            @click="removeFactoryUrl(index)"
          >
            ×
          </button>
        </div>
      </div>
      <div class="url-action">
        <button
          type="button"
          class="action-btn add-url-btn"
          @click="addFactoryUrl"
        >
          Add More Image URL
        </button>
      </div>
    </div>
    <div class="input__container">
      <label for="productionCapacity" class="form__label">Production Capacity (Optional, tons/day)</label>
      <input
        id="productionCapacity"
        type="number"
        class="form__input"
        placeholder=" "
        v-model="addMarkerForm.productionCapacity"
      />
    </div>
    <div class="input__container">
      <label for="processedVolume" class="form__label">Processed Volume (Optional, tons)</label>
      <input
        id="processedVolume"
        type="number"
        class="form__input"
        placeholder=" "
        v-model="addMarkerForm.processedVolume"
      />
    </div>
    <div class="input__container">
      <label for="inventoryLevels" class="form__label">Inventory Levels (Optional, tons)</label>
      <input
        id="inventoryLevels"
        type="number"
        class="form__input"
        placeholder=" "
        v-model="addMarkerForm.inventoryLevels"
      />
    </div>
  </div>

      <!-- For AP/Warehouse Marker -->
      <div v-if="modalTitle == 'AP/Warehouse Marker'" class="form__div">
        <SelectDropdown
          :options="['FFB', 'P1', 'P2', 'PKO', 'PKS']"
          class="select"
          dropdownTitle="Raw Material"
          @onInput="handleRawMaterialSelect"
          :reset="reset"
          @onReset="handleReset"
        />
      </div>
      <!-- Section for Biochar Application -->
      <div v-if="modalTitle === 'Biochar Application'" class="form__div">
        <div class="tabs">
          <button
            class="tab"
            :class="{ 'tab-active': activeTab === 'farmDetails' }"
            @click="activeTab = 'farmDetails'"
            type="button"
          >
            Farm Details
          </button>
          <button
            class="tab"
            :class="{ 'tab-active': activeTab === 'applicationDetails' }"
            @click="activeTab = 'applicationDetails'"
            type="button"
          >
            Application Details
          </button>
          <button
            class="tab"
            :class="{ 'tab-active': activeTab === 'transportMedia' }"
            @click="activeTab = 'transportMedia'"
            type="button"
          >
            Transport & Media
          </button>
        </div>

        <!-- Farm Details Tab -->
        <div v-show="activeTab === 'farmDetails'" class="tab-content">
          <div class="input__container">
            <label for="ownerName" class="form__label">Owner Name</label>
            <input
              id="ownerName"
              type="text"
              class="form__input"
              v-model="biocharApplicationForm.ownerName"
              required
            />
          </div>
          <div class="input__container">
            <label for="farmSize" class="form__label">Farm Size (ha)</label>
            <input
              id="farmSize"
              type="number"
              class="form__input"
              v-model="biocharApplicationForm.farmSize"
              required
            />
          </div>
          <div class="input__container">
            <label for="crop" class="form__label">Crop</label>
            <input
              id="crop"
              type="text"
              class="form__input"
              v-model="biocharApplicationForm.crop"
              required
            />
          </div>
          <div class="input__container">
            <label for="officerName" class="form__label">Officer Name</label>
            <input
              id="officerName"
              type="text"
              class="form__input"
              v-model="biocharApplicationForm.officerName"
              required
            />
          </div>
          <div class="input__container">
            <label for="officerEmail" class="form__label">Officer Email</label>
            <input
              id="officerEmail"
              type="text"
              class="form__input"
              v-model="biocharApplicationForm.officerEmail"
              required
            />
          </div>
          <div class="input__container">
            <label for="contactInfo" class="form__label">Contact Info</label>
            <input
              id="contactInfo"
              type="text"
              class="form__input"
              v-model="biocharApplicationForm.contactInfo"
              required
            />
          </div>
          <!-- <div class="input__container status-container">
              <label for="biocharStatus" class="form__label">Status</label>
              <SelectDropdown
                :options="['Active', 'Completed', 'Planned']"
                class="select"
                dropdownTitle="Status"
                @onInput="handleSelect"
                :reset="reset"
                @onReset="handleReset"
              />
            </div> -->
        </div>

        <!-- Application Details Tab -->
        <div v-show="activeTab === 'applicationDetails'" class="tab-content">
          <div class="input__container">
            <label for="startDate" class="form__label">Start Date</label>
            <input
              id="startDate"
              type="date"
              class="form__input"
              v-model="biocharApplicationForm.startDate"
              required
            />
          </div>
          <div class="input__container">
            <label for="endDate" class="form__label">End Date</label>
            <input
              id="endDate"
              type="date"
              class="form__input"
              v-model="biocharApplicationForm.endDate"
              required
            />
          </div>
          <div class="input__container">
            <label for="amountPerSpot" class="form__label"
              >Amount per Spot (kg)</label
            >
            <input
              id="amountPerSpot"
              type="number"
              class="form__input"
              v-model="biocharApplicationForm.amountPerSpot"
              required
            />
          </div>
          <div class="input__container">
            <label for="numberOfSpots" class="form__label"
              >Number of Spots</label
            >
            <input
              id="numberOfSpots"
              type="number"
              class="form__input"
              v-model="biocharApplicationForm.numberOfSpots"
              required
            />
          </div>
          <div class="input__container">
            <label for="amountOfBiochar" class="form__label"
              >Amount of Biochar (kg)</label
            >
            <input
              id="amountOfBiochar"
              type="number"
              class="form__input"
              v-model="biocharApplicationForm.amountOfBiochar"
              required
            />
          </div>
        </div>

        <!-- Transport & Media Tab -->
        <div v-show="activeTab === 'transportMedia'" class="tab-content">
          <div class="input__container status-container">
            <label for="transportVehicleType" class="form__label"
              >Transport Vehicle Type</label
            >
            <SelectDropdown
              :options="['Diesel', 'Petrol', 'CNG', 'Truck']"
              class="select"
              dropdownTitle="Transport Vehicle Type"
              @onInput="handleSelect"
              :reset="reset"
              @onReset="handleReset"
            />
          </div>
          <div class="input__container">
            <label class="form__label">Image URLs</label>
            <div class="url-inputs-container">
              <div
                v-for="(url, index) in biocharApplicationForm.imageUrls"
                :key="`url-${index}`"
                class="url-input-row"
              >
                <input
                  type="text"
                  class="form__input url-input"
                  v-model="biocharApplicationForm.imageUrls[index]"
                  placeholder="Enter Google drive Image URL"
                />
                <button
                  v-if="index !== 0"
                  type="button"
                  class="cancel-btn"
                  @click="removeUrl(index)"
                >
                  ×
                </button>
              </div>
            </div>
            <div class="url-action">
              <button
                type="button"
                class="action-btn add-url-btn"
                @click="addUrl"
              >
                Add More Image URL
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Section for Biochar Partner -->
      <div v-if="modalTitle === 'Biochar Partner'" class="form__div">
          <div class="input__container">
            <label for="partnerName" class="form__label">Partner Name</label>
            <input
              id="partnerName"
              type="text"
              class="form__input"
              v-model="biocharPartnerForm.name"
              required
            />
          </div>
          <div class="input__container status-container">
            <label for="biomassType" class="form__label">Biomass Type</label>
            <SelectDropdown
              :options='["Field Crops & Grains", "Tree Crops & Fruits", "Palm Kernel", "Industrial Processing Waste", "Food Waste", "Animal-based", "Wood"]'
              class="select"
              dropdownTitle="Biomass Type"
              @onInput="handleSelect"
              :reset="reset"
              @onReset="handleReset"
            />
          </div>
          <div class="input__container">
            <label class="form__label">Biomass Waste</label>
            <div class="url-inputs-container">
              <div
                v-for="(waste, index) in biocharPartnerForm.biomassWaste"
                :key="`waste-${index}`"
                class="url-input-row"
              >
                <input
                  type="text"
                  class="form__input url-input"
                  v-model="biocharPartnerForm.biomassWaste[index]"
                  placeholder="Enter biomass waste (e.g., rice husks, wood chips)"
                />
                <button
                  v-if="index !== 0"
                  type="button"
                  class="cancel-btn"
                  @click="removeBiomassWasteUrl(index)"
                >
                  ×
                </button>
              </div>
            </div>
            <div class="url-action">
              <button
                type="button"
                class="action-btn add-url-btn"
                @click="addBiomassWasteUrl"
              >
                Add More Biomass Waste
              </button>
            </div>
          </div>
          <div class="input__container">
            <label for="annualFeedstock" class="form__label">Annual Feedstock (tonnes)</label>
            <input
              id="annualFeedstock"
              type="number"
              class="form__input"
              v-model="biocharPartnerForm.annualFeedstock"
              placeholder="Total annual biomass feedstock available"
              required
            />
          </div>
          <div class="input__container">
            <label for="biocharProduction" class="form__label">Biochar Production (tonnes/year)</label>
            <input
              id="biocharProduction"
              type="number"
              class="form__input"
              v-model="biocharPartnerForm.biocharProduction"
              placeholder="Expected annual biochar production"
              required
            />
          </div>
          <div class="input__container">
            <label for="potentialMachineCost" class="form__label">Potential Machine Cost (₦)</label>
            <input
              id="potentialMachineCost"
              type="number"
              class="form__input"
              v-model="biocharPartnerForm.potentialMachineCost"
              placeholder="Estimated cost of biochar production equipment"
              required
            />
          </div>
          <div class="input__container">
            <label for="capexShareCommitted" class="form__label">CAPEX Share Committed (%)</label>
            <input
              id="capexShareCommitted"
              type="number"
              min="0"
              max="100"
              class="form__input"
              v-model="biocharPartnerForm.capexShareCommitted"
              placeholder="Percentage of capital expenditure committed by partner"
              required
            />
          </div>

      </div>
      <!-- For Logistics Depot -->
      <div v-if="modalTitle == 'Logistics Depot'" class="input__container">
        <label for="costPMS" class="form__label">PMS Cost</label>
        <input
          id="costPMS"
          type="number"
          class="form__input"
          placeholder=" "
          v-model="customerPayLoad.costPMS"
        />
      </div>
      <div v-if="modalTitle == 'Logistics Depot'" class="input__container">
        <label for="costAGO" class="form__label">AGO Cost</label>
        <input
          id="costAGO"
          type="number"
          class="form__input"
          placeholder=" "
          v-model="customerPayLoad.costAGO"
        />
      </div>
      <div v-if="modalTitle !== 'Biochar Application' &&  modalTitle !== 'Biochar Partner'" class="form__div">
        <SelectDropdown
          :options="[
            'Active',
            'Inactive',
            'Underconstruction',
            'Planned (2025)',
            'Planned (2026)',
          ]"
          class="select"
          dropdownTitle="Status"
          @onInput="handleSelect"
          :reset="reset"
          @onReset="handleReset"
        />
      </div>

      <div class="btn-container">
        <button
          type="submit"
          :class="isFormEmpty ? 'dis' : 'add-marker-btn'"
          :disabled="isFormEmpty"
        >
          Add<span
            v-if="loading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import SelectDropdown from "../map/SelectDropdown.vue";

export default {
  name: "AddMarkerForm",
  components: {
    SelectDropdown,
  },
  props: {
    modalTitle: {
      type: String,
      required: true,
    },
    markerFormAction: {
      type: String,
      required: false,
    },
    markerToBeUpdated: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selected: [],
      selectedBiocharMaterials: [],
      activeTab: "farmDetails",
      options: [
        { item: "FFB", name: "FFB" },
        { item: "P1", name: "P1" },
        { item: "P2", name: "P2" },
        { item: "PKO", name: "PKO" },
        { item: "AGO", name: "AGO" },
      ],
      biocharMaterialOptions: [
        { item: "PKS", name: "PKS" },
        { item: "Maize", name: "Maize" },
        { item: "Factory Waste", name: "Factory Waste" },
      ],
      reset: false,
      showAddMarkerModal: false,
      loading: false,
      addMarkerForm: {
        name: "",
        rawMaterials: "",
        type: "",
        status: "",
        inputRate: "",
        createdBy: "admin",
        imageUrls: [""], 
        productionCapacity: "", 
        processedVolume: "",
        inventoryLevels: "",

      },
      logisticsPayload: {
        name: "",
        gas: [],
        status: "",
        createdBy: "admin",
      },
      customerPayLoad: {
        name: "",
        phoneNumber: "",
        costPMS: "",
        costAGO: "",
        latitude: 0,
        longitude: 0,
        rawMaterials: [],
        factoryType: "",
        status: "",
        createdBy: "admin",
      },
      APMarkerForm: {
        name: "",
        status: "",
        createdBy: "admin",
      },
      biocharApplicationForm: {
        ownerName: "",
        farmSize: "",
        crop: "",
        startDate: "",
        endDate: "",
        amountPerSpot: "",
        numberOfSpots: "",
        amountOfBiochar: "",
        transportVehicleType: "",
        officerName: "",
        officerEmail: "",
        contactInfo: "",
        imageUrls: [""],
        // status: "",
        createdBy: "admin",
      },
      biocharPartnerForm: {
        name: "",
        biomassType: "",
        biomassWaste: [""],
        annualFeedstock: "",
        biocharProduction: "",
        potentialMachineCost: "",
        capexShareCommitted: "",
        createdBy: "admin",
      }
    };
  },
  methods: {
    closeModal() {
      this.showAddMarkerModal = false;
      this.$emit("onCloseModal", this.showAddMarkerModal);
    },
    addFactoryUrl() {
      this.addMarkerForm.imageUrls.push("");
    },
    removeFactoryUrl(index) {
      this.addMarkerForm.imageUrls.splice(index, 1);
      if (this.addMarkerForm.imageUrls.length === 0) {
        this.addMarkerForm.imageUrls.push("");
      }
    },
    resetForm() {
      this.reset = true;
      this.addMarkerForm = {
        name: "",
        rawMaterials: "",
        type: "",
        status: "",
        inputRate: "",
        createdBy: "admin",
        imageUrls: [""],
        productionCapacity: "",
        processedVolume: "",
        inventoryLevels: "",
      };
      this.biocharApplicationForm = {
        ownerName: "",
        farmSize: "",
        crop: "",
        startDate: "",
        endDate: "",
        amountPerSpot: "",
        numberOfSpots: "",
        amountOfBiochar: "",
        transportVehicleType: "",
        contactInfo: "",
        officerName: "",
        officerEmail: "",
        imageUrls: [""],
        // status: "",
        createdBy: "admin",
      };
      this.biocharPartnerForm = {
        name: "",
        biomassType: "",
        biomassWaste: [""],
        annualFeedstock: "",
        biocharProduction: "",
        potentialMachineCost: "",
        capexShareCommitted: "",
        createdBy: "admin",
      };
      this.selected = [];
      this.selectedBiocharMaterials = [];
      this.activeTab = "farmDetails";
    },
    handleReset(value) {
      this.reset = value;
    },
    async getMarkers() {
      try {
        await this.$store.dispatch("markers/fetchMarkers");
      } catch (error) {
        console.error("Error fetching markers:", error);
      }
    },
    handleSelect(obj) {
      if (this.modalTitle === "Biochar Application") {
        this.biocharApplicationForm = {
          ...this.biocharApplicationForm,
          ...obj,
        };
      } else if (this.modalTitle === "Biochar Partner") {
        this.biocharPartnerForm = {
          ...this.biocharPartnerForm,
          ...obj,
        };
      } 
      else {
        this.addMarkerForm = {
          ...this.addMarkerForm,
          ...obj,
        };
      }
    },
    handleRawMaterialSelect(obj) {
      this.addMarkerForm = {
        ...this.addMarkerForm,
        rawMaterials: obj.rawMaterials || obj.rawMaterial || obj.value || "",
      };
    },
    addUrl() {
      this.biocharApplicationForm.imageUrls.push("");
    },
    removeUrl(index) {
      this.biocharApplicationForm.imageUrls.splice(index, 1);
      if (this.biocharApplicationForm.imageUrls.length === 0) {
        this.biocharApplicationForm.imageUrls.push("");
      }
    },
    addBiomassWasteUrl() {
      this.biocharPartnerForm.biomassWaste.push("");
    },
    removeBiomassWasteUrl(index) {
      this.biocharPartnerForm.biomassWaste.splice(index, 1);
      if (this.biocharPartnerForm.biomassWaste.length === 0) {
        this.biocharPartnerForm.biomassWaste.push("");
      }
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.loading = true;

      let markerType = "";

      if (this.modalTitle === "AP/Warehouse Marker") {
        markerType = "AP";
      } else if (this.modalTitle === "Factory Marker") {
        markerType = "Factory";
      } else if (this.modalTitle === "Customer Factory") {
        markerType = "Customer";
      } else if (this.modalTitle === "Biochar Application") {
        markerType = "BiocharApplication";
      } else if (this.modalTitle === "Biochar Partner") {
        markerType = "BiocharPartner";
      } else {
        markerType = "Logistics";
      }

      const clickedPoint = this.$store.getters["markers/getClickedLocation"];

      try {
        let resp;
        if (markerType === "Customer") {
          this.customerPayLoad = {
            name: this.addMarkerForm.name,
            phoneNumber: this.addMarkerForm.phoneNumber,
            latitude: clickedPoint.latitude,
            longitude: clickedPoint.longitude,
            factoryType: this.addMarkerForm.type,
            rawMaterials: this.selected,
            status: this.addMarkerForm.status,
            createdBy: "admin",
            costPMS: this.customerPayLoad.costPMS || "Nil",
            costAGO: this.customerPayLoad.costAGO || "Nil",
          };
          resp = await this.$store.dispatch(
            "markers/addCustomer",
            this.customerPayLoad
          );
        } else if (markerType === "Logistics") {
          this.logisticsPayload = {
            name: this.addMarkerForm.name,
            gas: [
              { name: "PMS", cost: this.customerPayLoad.costPMS || "Nil" },
              { name: "AGO", cost: this.customerPayLoad.costAGO || "Nil" },
            ],
            latitude: clickedPoint.latitude,
            longitude: clickedPoint.longitude,
            status: this.addMarkerForm.status,
            createdBy: "admin",
          };
          resp = await this.$store.dispatch(
            "markers/addLogisticsDepot",
            this.logisticsPayload
          );
        } else if (markerType === "AP") {
          this.APMarkerForm = {
            name: this.addMarkerForm.name,
            latitude: clickedPoint.latitude,
            longitude: clickedPoint.longitude,
            rawMaterials: this.addMarkerForm.rawMaterials,
            markerType: "AP",
            status: this.addMarkerForm.status,
            createdBy: "admin",
          };
          resp = await this.$store.dispatch(
            "markers/addMarker",
            this.APMarkerForm
          );
        } else if (markerType === "BiocharApplication") {
          const payload = {
            ownerName: this.biocharApplicationForm.ownerName || "",
            farmSize: Number(this.biocharApplicationForm.farmSize) || 0,
            crop: this.biocharApplicationForm.crop || "",
            startDate: this.biocharApplicationForm.startDate || "",
            endDate: this.biocharApplicationForm.endDate || "",
            amountPerSpot:
              Number(this.biocharApplicationForm.amountPerSpot) || 0,
            numberOfSpots:
              Number(this.biocharApplicationForm.numberOfSpots) || 0,
            amountOfBiochar:
              Number(this.biocharApplicationForm.amountOfBiochar) || 0,
            transportVehicleType:
              this.biocharApplicationForm.transportVehicleType || "",
            contactInfo: this.biocharApplicationForm.contactInfo || "",
            officerName: this.biocharApplicationForm.officerName || "",
            officerEmail: this.biocharApplicationForm.officerEmail || "",
            imageUrls: this.biocharApplicationForm.imageUrls
              .filter((url) => url.trim() !== "")
              .map((url) => url.trim()),
            // status: this.biocharApplicationForm.status || "",
            createdBy: this.biocharApplicationForm.createdBy || "admin",
            latitude: Number(clickedPoint?.latitude || 0),
            longitude: Number(clickedPoint?.longitude || 0),
          };
          resp = await this.$store.dispatch(
            "markers/addBiocharApplication",
            payload
          );
        } else if (markerType === "BiocharPartner") {
          const payload = {
            name: this.biocharPartnerForm.name,
            latitude: clickedPoint.latitude,
            longitude: clickedPoint.longitude,
            biomassType: this.biocharPartnerForm.biomassType || "",
            biomassWaste: this.biocharPartnerForm.biomassWaste
              .filter((waste) => waste.trim() !== "")
              .map((waste) => waste.trim()),
            annualFeedstock: Number(this.biocharPartnerForm.annualFeedstock) || 0,
            biocharProduction: Number(this.biocharPartnerForm.biocharProduction) || 0,
            potentialMachineCost:
              Number(this.biocharPartnerForm.potentialMachineCost) || 0,
            capexShareCommitted:
              Number(this.biocharPartnerForm.capexShareCommitted) || 0,
            createdBy: "admin",
          };
          resp = await this.$store.dispatch(
            "markers/addBiocharPartner",
            payload
          );
        } else {
          const payload = {
            name: this.addMarkerForm.name,
            latitude: clickedPoint.latitude,
            longitude: clickedPoint.longitude,
            markerType,
            type: this.addMarkerForm.type,
            status: this.addMarkerForm.status,
            createdBy: this.addMarkerForm.createdBy,
            imageUrls: this.addMarkerForm.imageUrls
              .filter((url) => url.trim() !== "")
              .map((url) => url.trim()),
            productionCapacity: this.addMarkerForm.productionCapacity
              ? Number(this.addMarkerForm.productionCapacity)
              : undefined,
            processedVolume: this.addMarkerForm.processedVolume
              ? Number(this.addMarkerForm.processedVolume)
              : undefined,
            inventoryLevels: this.addMarkerForm.inventoryLevels
              ? Number(this.addMarkerForm.inventoryLevels)
              : undefined,
          };
          if (this.addMarkerForm.type === "Biochar Facility") {
            payload.biocharMaterials = this.selectedBiocharMaterials;
            payload.inputRate = this.addMarkerForm.inputRate || "0";
            delete payload.rawMaterials;
          } else {
            payload.rawMaterials = this.addMarkerForm.rawMaterials;
          }
          resp = await this.$store.dispatch("markers/addMarker", payload);
        }
        if (resp.status === 201) {
          this.$toastr.s(`${this.modalTitle} Added Successfully`);
          await this.getMarkers();
          this.resetForm();
          this.closeModal();
        }
      } catch (error) {
        console.error("Error adding marker:", error);
        this.$toastr.e("Failed to add marker");
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    getMarkerTypeName() {
      return this.modalTitle.split(" ")[0];
    },
    isFormEmpty() {
      if (this.modalTitle === "Factory Marker") {
        if (this.addMarkerForm.type === "Biochar Facility") {
          return (
            !this.addMarkerForm.name?.length ||
            !this.addMarkerForm.status?.length ||
            !this.addMarkerForm.type?.length ||
            !this.selectedBiocharMaterials.length
            // !this.addMarkerForm.inputRate
          );
        } else {
          return (
            !this.addMarkerForm.name?.length ||
            !this.addMarkerForm.status?.length ||
            !this.addMarkerForm.type?.length ||
            !this.addMarkerForm.rawMaterials?.length
          );
        }
      } else if (this.modalTitle === "Customer Factory") {
        return (
          !this.addMarkerForm.name?.length ||
          !this.addMarkerForm.status?.length ||
          !this.addMarkerForm.type?.length ||
          !this.selected.length
        );
      } else if (this.modalTitle === "AP/Warehouse Marker") {
        return (
          !this.addMarkerForm.name?.length ||
          !this.addMarkerForm.status?.length ||
          !this.addMarkerForm.rawMaterials?.length
        );
      } else if (this.modalTitle === "Biochar Application") {
        const hasValidImageUrls = this.biocharApplicationForm.imageUrls.some(
          (url) => url.trim().length > 0
        );
        return (
          !this.biocharApplicationForm.ownerName?.length ||
          !this.biocharApplicationForm.farmSize ||
          !this.biocharApplicationForm.crop?.length ||
          !this.biocharApplicationForm.startDate?.length ||
          !this.biocharApplicationForm.endDate?.length ||
          !this.biocharApplicationForm.amountPerSpot ||
          !this.biocharApplicationForm.numberOfSpots ||
          !this.biocharApplicationForm.amountOfBiochar ||
          !this.biocharApplicationForm.transportVehicleType?.length ||
          !this.biocharApplicationForm.contactInfo?.length ||
          !this.biocharApplicationForm.officerName?.length ||
          !this.biocharApplicationForm.officerEmail?.length ||
          !hasValidImageUrls
        );
      } else if (this.modalTitle === "Biochar Partner") {
        return (
          !this.biocharPartnerForm.name?.length ||
          !this.biocharPartnerForm.biomassType.length ||
          !this.biocharPartnerForm.biomassWaste.length > 0  ||
          !this.biocharPartnerForm.annualFeedstock ||
          !this.biocharPartnerForm.biocharProduction ||
          !this.biocharPartnerForm.potentialMachineCost ||
          !this.biocharPartnerForm.capexShareCommitted
        );
      }else {
        return (
          !this.addMarkerForm.name?.length || !this.addMarkerForm.status?.length
        );
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  z-index: 9990;
}

.form {
  width: 100%;
  margin: 0 auto;
  padding: 1rem 0rem;
}

.form-title {
  font-weight: 600;
}

.close-modal {
  position: absolute;
  top: -3px;
  right: 0.2rem;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  border: none;
  background: none;
}

.input__container {
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  border: 1px solid #fff;
}

.form__div {
  position: relative;
  margin-bottom: 0.8rem;
  width: 100%;
}

.form__input {
  width: 100%;
  height: 11%;
  font-size: 0.7rem;
  border: 1.5px solid #669933;
  border-radius: 5px;
  outline: none;
  padding: 0.8rem;
  background: none;
  text-align: left;
  z-index: 1;
}

.form__label {
  padding: 0 0.25rem;
  color: #827e7e;
  font-size: 0.8rem;
  margin-bottom: 0.3rem !important;
  transition: 0.3s;
}

.form__button:hover {
  box-shadow: 0 10px 36px rgba(0, 0, 0, 0.15);
}

.form__input::placeholder {
  color: #ccc;
}

.form__input:focus {
  border: 1.5px solid #669933;
}

.btn-container {
  display: flex;
}

.add-marker-btn {
  margin-left: auto;
  color: #fff;
  background-color: #669933;
  width: 20%;
  border-radius: 5px;
  text-align: center;
  padding: 5px;
  font-size: 13px;
}

.dis:disabled {
  margin-left: auto;
  color: #fff;
  background-color: #669933;
  width: 20%;
  border-radius: 5px;
  text-align: center;
  padding: 5px;
  font-size: 13px;
  opacity: 0.7;
}
.tabs {
  display: flex;
}

.tab {
  flex: 1;
  padding: 0.8rem;
  background: #f5f5f5;
  border: none;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.tab:hover {
  background: #e8e8e8;
}

.tab-active {
  background: #669933;
  color: #fff;
}

.tab-content {
  padding: 1rem 0;
}
.url-inputs-container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1rem;
  width: 100%;
}

.url-input-row {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
}
.url-input {
  flex: 1;
  position: relative;
  height: auto;
  padding: 0.5rem;
  font-size: 0.9rem;
}
.form__input.url-input {
  position: relative;
  height: 11%;
  top: auto;
  left: auto;
  z-index: auto;
}

.cancel-btn {
  background: none;
  border: none;
  color: #ff4d4d;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-action {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.action-btn {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background: #669933;
  color: #fff;
}

.action-btn:hover {
  background: #4a6b22;
}

.status-container {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.select {
  margin-bottom: 1rem;
}

input[type="date"] {
  font-family: inherit;
}

@media screen and (max-width: 768px) {
  .tabs {
    flex-direction: column;
  }
  .tab {
    border-radius: 0;
  }
  .tab:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .tab:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .add-marker-btn,
  .dis {
    width: 40%;
    padding: 8px;
  }
}
</style>
